@if (loading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<form class="download" [formGroup]="downloadForm" (ngSubmit)="onSubmit()">
  <a target="_blank" href="https://fullyops.com/">
    <img
      class="client-logo"
      src="assets/svg/fullyops-logo-white.svg"
      alt="FullyOps Logo"
    />
  </a>
  <br />
  <br />
  <p>
    @if (tokenizedAsset$ | async) {
      <label
        >{{ 'translation:downloadValidTokenMessage' | i18nextCap
        }}{{ tenantName }}.
      </label>
    } @else {
      <label
        >{{ 'translation:downloadInvalidTokenMessage' | i18nextCap }}
      </label>
    }
  </p>
  @if (tokenizedAsset$ | async) {
    <div class="download-button-wrapper">
      <button class="btn-flip">
        {{ 'translation:downloadSubmitBtnLabel' | i18nextCap }}
      </button>
    </div>
  }
  <br />
  <p>
    <a target="_blank" href="https://fullyops.com">{{
      'translation:downloadKnowMore' | i18next
    }}</a>
  </p>
</form>
